/* eslint-disable no-console */

import React from 'react';
import styled from 'styled-components/macro';
import { Layout } from 'components/organisms';
import { PeopleList } from 'containers';
import {
  Title, Text, Spacer, Icon
} from 'components/atoms';
import {
  useParams, Link, Route, matchPath, useLocation
} from 'react-router-dom';
import { useUserContext } from 'context/UserContext';
import { PORTAL_WWW } from 'services/constants'
import PeopleSideDetail from './PeopleSideDetail'

const ThePage = () => {
  const { subweb, lang } = useParams();
  const { pathname } = useLocation();
  const [{ user }] = useUserContext();


  const peopleId = React.useMemo(() => {
    const match = matchPath(pathname, {
      path: '/:subweb/people/:peopleId',
      exact: false,
    });
    if (match && match.params && match.params.peopleId) return match.params.peopleId;
    return null;
  }, [pathname]);

  const subwebData = React.useMemo(() => {
    if (!user || !user.subwebs || !user.subwebs.length > 0) return null
    const data = user.subwebs.find(
      subwebData => subwebData.slug === subweb || encodeURIComponent(subwebData.slug) === subweb
    )
    return data
  }, [subweb, user])

  return (
    <Layout modifiers={['stretch']}>
      <SideBySide>
        <SideBySide.Start>
          <Top>
            {subwebData && subwebData.description && (
              <Link to={`/${subweb}`}>
                <Title>{subwebData.description}</Title>
              </Link>
            )}
            <InlineAnchor href={`${PORTAL_WWW}/${subweb}/pessoas`} target="_blank" rel="noopener noreferrer">
              <Text modifiers={['light']}>
                pessoas
              </Text>
              <Spacer left="xs3">
                <Icon icon="fal fa-external-link" height={12} />
              </Spacer>
            </InlineAnchor>
          </Top>
          <PeopleList
            lang={lang}
            subweb={subweb}
            activePeopleId={peopleId}
          />
        </SideBySide.Start>
        <SideBySide.End>
          <Route path="/:subweb/people/:peopleId" component={PeopleSideDetail} />
          <Route exact path="/:subweb/people" component={PeopleSideDetail} />
        </SideBySide.End>
      </SideBySide>
    </Layout>
  );
};

const SideBySide = styled.div`
  display: grid;
  grid-template-columns: 1fr ${props => props.theme.components.layout.sideWidth};
  height: 100%;
`;

SideBySide.Start = styled.div`
  padding: ${props => `
  ${props.theme.components.layout.paddingVertical}
  ${' '}
  ${props.theme.components.layout.paddingHorizontal}
  `};
`

SideBySide.End = styled.div`
  padding: ${props => `
  ${props.theme.components.layout.paddingVertical}
  ${' '}
  ${props.theme.components.layout.paddingHorizontal}
  `};
  background-color: ${props => props.theme.colors.bgLighterS};
  border-left: 2px solid ${props => props.theme.colors.borderLighter};
`

const Top = styled.div`
  margin-bottom: ${props => props.theme.spacing.l};
  padding-bottom: ${props => props.theme.spacing.xl4};
  display: inline-flex;
  width: 100%;
  flex-direction: column;
  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`

const InlineAnchor = styled.a`
  display: flex;
  align-items: center;
`

export default ThePage;
